import { render, staticRenderFns } from "./AllIPSetLists.vue?vue&type=template&id=815d4ae8&"
import script from "./AllIPSetLists.vue?vue&type=script&lang=ts&"
export * from "./AllIPSetLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports